export const initialFormValues = {
    email: "",
    password: "",
    firstName:"",
    lastName:"",
  };
  export const testLogin = {
    email: "testricha@gmail.com",
    password: "testlogin123@",
  };